module.exports = __webpack_public_path__ + "static/13-2338dd0e3d9a063d20d8fd807cd02e0d.jpg";